import { AxiosResponse } from "axios";
import BaseDAO from "../BaseDAO";
import LogUtil, { LogRequestTipo } from "../../util/LogUtil";

class C5BaseDAO extends BaseDAO {
  protected basePath: string = "https://api.consinco.com.br/v2.7";

  protected getBasePath(): string {
    return this.basePath;
  }

  private config: any = {
    headers: {
      "Content-Type": "application/json",
      Token: "8BA8-4F26-8177",
      Key:
        "D8479263F86340DB8C12C35461791596B9A5A9F448B34213BF4280FBFE586E0C040BBD606CC844E3B9CE953AE4E4CC89",
    },
  };

  private configForgot: any = {
    headers: {
      "Content-Type": "application/json",
      headers: {
        // tslint:disable-next-line:max-line-length
        Authorization: `Bearer OzG3L4nAnYYu_DkLnYaAN6nlLgU1N5tWLPAViiMjgDLR6ifFijE4NytRBabV3x0XBTeqwNSZEdh3sV9-FscxZTbFiMtcSTsRyM-gefA7JOeKO6_iMA0A4FuNmno1768jOvMMJTYEF3Ef9Hp3w6SkR1VbjdneYCkt61rNX6sATAc3Fk11o2WecMkGwBrwZmzT2E-wvj-1-nIf_4Dx8UDed3t2cPrwOm83gTGXlIZszeow43uOBysF97Q9p4i9vidNjNnV1lHqFTLXZgV4wukpl_bENai3aJuPrbadR8L4xh_KMqOavZ8JJBVafBqZ92Bkv6a-GwHpb_wr25R5PBmIBR-R6WaGagI2F9ECcgiDmpyoTA6Jb2_20IHsoU3qEBBG3rEfo58i4ZE8GCFHiAohSxJuGRMl_Uge5WHa_Jhoz7P2a2fwNxQEX2smXZLffPPiwRJ01WmofEbd7PdKwEV4Cks6Z05AhvS0_d6wYaQgAMpORZf_9NwA4rY3eu6UZqvX`,
      },
    },
  };

  public get(key: string, url: string): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.GET, key, url, null);
    return super.get(key, url, this.config);
  }

  public post(
    key: string,
    url: string,
    body: any
  ): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.POST, key, url, {
      body,
      config: this.config,
    });
    return super.post(url, body, this.config);
  }

  public postForgot(
    key: string,
    url: string,
    body: any
  ): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.POST, key, url, {
      body,
      config: this.configForgot,
    });
    return super.post(url, body, this.configForgot);
  }

  public patch(
    key: string,
    url: string,
    body: any
  ): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.PATCH, key, url, {
      body,
      config: this.config,
    });
    return super.patch(url, body, this.config);
  }

  public put(key: string, url: string, body: any): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.PATCH, key, url, {
      body,
      config: this.config,
    });
    return super.put(url, body, this.config);
  }

  public delete(
    key: string,
    url: string,
    body: any
  ): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.DELETE, key, url, {
      body,
      config: this.config,
    });
    return super.delete(url, body, this.config);
  }
}

export default C5BaseDAO;
